import React, { useEffect, useRef } from "react";
import { toast } from "sonner";
import { exchangeGoogleSession } from "@/lib/customerAuth";

// Detects `#session_id=...` on the URL fragment after returning from the
// Emergent OAuth flow, exchanges it for our customer JWT, and cleans the
// hash. Renders nothing.
//
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export const AuthCallbackHandler = ({ onAuthed }) => {
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    const hash = window.location.hash || "";
    if (!hash.includes("session_id=")) return;
    processed.current = true;

    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sid = params.get("session_id");
    if (!sid) return;

    const t = toast.loading("Signing you in with Google…");
    exchangeGoogleSession(sid)
      .then((data) => {
        toast.success(`Welcome${data?.customer?.name ? `, ${data.customer.name}` : ""}!`, {
          id: t,
          duration: 2400,
        });
        onAuthed?.(data?.customer);
        // Strip the hash so it can't be re-processed on refresh.
        const cleaned = window.location.pathname + window.location.search;
        window.history.replaceState(null, "", cleaned);
      })
      .catch((e) => {
        toast.error(e?.message || "Google sign-in failed. Please try again.", {
          id: t,
        });
        const cleaned = window.location.pathname + window.location.search;
        window.history.replaceState(null, "", cleaned);
      });
  }, [onAuthed]);

  return null;
};
